const headerMixin = {
	data() {
		return {
			menuIsOpen: false
		}
	},
	methods: {
		toggleMenu() {
			this.menuIsOpen = !this.menuIsOpen;
		}
	}
}
